export default __webpack_public_path__ + "static/media/AACLogo6.48569758.png";